import { AxiosError } from "axios";
import axiosInstance from "@/api/axiosInstance";
import type { Product } from "@/components/types";

export class AccommodationsService {
  public async getAll(): Promise<any> {
    try {
      const url = `/api/v1/admin/accommodations`;
      const response = await axiosInstance.get(url);
      return response.data;
    } catch (e: unknown) {
      console.log("Admin accommodation list endpoint threw error", e);
    }
  }

  /** Errors propagate: the view classifies them and renders the failure in place. */
  public async getAccommodation(id: string): Promise<any> {
    const url = `/api/v1/admin/accommodations/${id}`;
    const response = await axiosInstance.get(url);
    return response.data;
  }

  public async createProduct(
    accommodationId: number,
    newProduct: any
  ): Promise<any> {
    const requestBody = {
      accommodationId: accommodationId,
      name: newProduct.name,
      grossPricePerPersonPerNight: parseInt(
        newProduct.grossPricePerPersonPerNight
      ),
    };
    try {
      const response = await axiosInstance.post(
        `/api/v1/admin/product`,
        requestBody
      );
      return response.data;
    } catch (e) {
      if (e instanceof AxiosError && e.response?.status !== 404) {
        throw e;
      }
    }
  }

  public async updateProduct(newProduct: any): Promise<any> {
    const requestBody = {
      name: newProduct.name,
      grossPricePerPersonPerNight: parseInt(
        newProduct.grossPricePerPersonPerNight
      ),
    };
    try {
      const response = await axiosInstance.put(
        `/api/v1/admin/product/${newProduct.id}`,
        requestBody
      );
      return response.data;
    } catch (e) {
      if (e instanceof AxiosError && e.response?.status !== 404) {
        throw e;
      }
    }
  }

  public async createAccommodation(accommodation: {
    name: string;
    city: string;
    address: string;
    billingAddress: string;
    phoneNumber: string;
    email: string;
  }): Promise<any> {
    const response = await axiosInstance.post(
      `/api/v1/admin/accommodations/create`,
      accommodation
    );
    return response.data;
  }

  public async updateAccommodation(
    id: number,
    accommodation: {
      name: string;
      city: string;
      address: string;
      billingAddress: string;
      phoneNumber: string;
      email: string;
    }
  ): Promise<any> {
    const response = await axiosInstance.put(
      `/api/v1/admin/accommodations/${id}`,
      accommodation
    );
    return response.data;
  }

  public async deleteProduct(id: string): Promise<any> {
    try {
      const url = `/api/v1/admin/product/${id}`;
      const response = await axiosInstance.delete(url);
      console.log("Delete product request successful");
      return response.data;
    } catch (e: unknown) {
      if (e instanceof AxiosError && e.response?.status !== 404) {
        throw e;
      }
    }
  }
}
